import React from "react";
import PropTypes from "prop-types";
import { Anchor, Box, Heading, Text } from 'grommet'

const PrivacyPolicy = () => {

}

const TermsAndConditions = () => {

}

const Footer = (props) => (
  <Box direction='column'> 
    {/*<Box
      background='transparent'
      basis='full' 
      direction='row-responsive'
      margin={{ bottom: 'small', left: 'large', top: 'medium' }}
    >
      <Box 
          align="start" 
          basis='1/4'
          fill="vertical" 
      >
        <Heading color='brand' level='4' >company</Heading> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
      </Box>
      <Box 
          align="start" 
          basis='1/4' 
          fill="vertical" 
      >
        <Heading color='brand' level='4' >platform</Heading> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
      </Box>
      <Box 
          align="start" 
          basis='1/4' 
          fill="vertical" 
      >
        <Heading color='brand' level='4' >apps</Heading> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
      </Box>
      <Box 
          align="start" 
          basis='1/4' 
          fill="vertical" 
      >
        <Heading color='brand' level='4' >community</Heading> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
        <Anchor label='link one' plain /> 
      </Box>*/}
    <Box>
      <Box 
          align="center" 
          alignContent="center" 
          alignSelf="center"
          margin="large" 
      >
        <Text color='brand' weight='bold'>read our <Anchor href="#" primary label="terms and conditions" /> and <Anchor href="#" primary label="privacy policy" /></Text>
      </Box>
    </Box>
  </Box>
)

export default Footer
